import { html } from 'lit';
import { DollarSign } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-dollar-sign')
export class PdsIconDollarSign extends PdsIcon {
  @state()
  icon = DollarSign;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
